import { ResourceType } from './resource.types';

/**
 * Resource-type spellings that are no longer part of {@link ResourceType} but can
 * still arrive from outside this deployment.
 *
 * `trigger` was the standalone cron-trigger type. Its rows were deleted and its
 * tables dropped by `1776772848406-migrate-cron-agent-triggers-to-workflows`, and
 * every code path that still named it was reading `workflow_triggers_cron` — the
 * {@link ResourceType.WorkflowTrigger} table. The type is gone from the model, but
 * the string can still reach us from a bookmarked URL, a cached client bundle, or
 * a `resource_share_links.targets` JSON entry that predates the migration, so it
 * is translated rather than rejected.
 */
const LEGACY_RESOURCE_TYPE_ALIASES: Readonly<Record<string, ResourceType>> = {
  trigger: ResourceType.WorkflowTrigger,
};

const RESOURCE_TYPE_VALUES = new Set<string>(Object.values(ResourceType));

/**
 * Narrow an untrusted string to a {@link ResourceType}, translating legacy
 * spellings. Returns null when the value names no resource type at all, so
 * callers can answer 404 rather than 500.
 */
export const parseResourceType = (raw: string): ResourceType | null => {
  if (RESOURCE_TYPE_VALUES.has(raw)) {
    return raw as ResourceType;
  }
  return LEGACY_RESOURCE_TYPE_ALIASES[raw] ?? null;
};
